import React from "react";
import { SearchResults } from "./SearchPage";
import { RESULT_PAGE_LIMIT } from "../../pages/search";
import PageResultItem from "./PageResultItem";
import styled from "styled-components";
import EmptyResultsTab from "./EmptyResultsTab";
import SearchPagination from "./SearchPagination";

export const ResultsContainer = styled.div`
  min-height: 50vh;
  padding: calc(4px * 12) 0;

  > ul {
    margin: 0;
    padding: 0;
  }
`;

interface Props {
  results: SearchResults;
  page: number;
  name: string;
}
export default function ProgramTab(props: Props) {
  const { results, page, name } = props;
  if (!results.total) return <EmptyResultsTab />;
  return (
    <ResultsContainer>
      <SearchPagination
        {...results}
        name={name}
        wrapperTag={"ul"}
        renderItem={(item, idx) => (
          <PageResultItem
            key={`${item.id}+${idx}`}
            id={item.id}
            title={item.title}
            href={item.url}
            description={item.description}
          />
        )}
        renderEmpty={() => null}
        pageSize={RESULT_PAGE_LIMIT}
        page={page - 1}
      />
    </ResultsContainer>
  );
}
